import { useLocation } from 'components/ReactRouterProvider/context'

const useQuery = () => new URLSearchParams(useLocation().search)
export default useQuery
